export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6290.8b13a99c.jpg";